/** GraphQL mutation to update qty. */

export default `
  mutation updateQty($cart_id: String!, $qty: Int!) {
    xmasUpdateQty(cart_id: $cart_id, qty: $qty) {
      cart {
        id
        email
        total_quantity
        items {
          uid
          additional_data
          product {
            id
            uid
            __typename
            sku
            name
            thumbnail {
              url
              position
              disabled
              label
            }
            url_key
            url_rewrites {
              url
            }
          }
          prices {
            row_total {
              value
            }
            row_total_including_tax {
              value
            }
            total_item_discount {
              value
            }
          }
          quantity
        }
      }
    }
  }
`;
